"use strict";
// LIBS
import { TweenMax } from "./vendor/gsap-new/gsap";
import Waypoint from "./vendor/waypoints";
import "babel-polyfill";

// MODULES
import OuterHeaven from "./base/outerheaven.js";
import BarbaPopin from "./components/BarbaPopin.js";
import BrowserDetection from "./base/detection.js";
import Env from "./base/env.js";
import Toolbox from "./base/toolbox.js";
import Channels from "./base/channels.js";
import MainTransition from "./transition/TransitionMain";
import Home from "./view/home.js";
import MoodIndex from "./view/mood-index.js";
import MagIndex from "./view/mag-index.js";
import MoodSingle from "./view/mood-single.js";
import NewsSingle from "./view/news-single.js";
import About from "./view/about.js";
import AgenceIndex from "./view/agence-index.js";
import PressIndex from "./view/press-index.js";
import Good from "./view/good.js";
import Newsletter from "./view/newsletter.js";
import Forward from "./view/forward.js";
import UI from "./view/ui.js";

document.addEventListener("DOMContentLoaded", function () {
  // Starter
  Env.framework.toolbox = new Toolbox();
  new BrowserDetection();
  window.addEventListener("resize", function () {
    clearTimeout(window.resizedFinished);
    window.resizedFinished = setTimeout(function () {
      Channels.emit("window::smartresize");
    }, 200);
  });

  // Views
  Env.framework.UI = new UI();
  Env.framework.MainTransition = new MainTransition();
  Env.framework.popin = new BarbaPopin();
  Home.init();
  MoodIndex.init();
  MagIndex.init();
  MoodSingle.init();
  NewsSingle.init();
  About.init();
  AgenceIndex.init();
  PressIndex.init();
  Good.init();
  Newsletter.init();
  Forward.init();

  // Signature
  if (navigator.userAgent.toLowerCase().indexOf("chrome") > -1) {
    var args = [
      "\n %c with <3 by @jcsuzanne \u2730 http://www.jcsuzanne.com/ \n\n",
      "background: #ffcc33; padding:5px 0;color: #333333;",
    ];
    window.console.log.apply(console, args);
  } else if (window.console) {
    window.console.log("@jcsuzanne - http://www.jcsuzanne.com/");
  }

  // Start Barba
  new OuterHeaven();

  // PWA
  if (config.env === "production") {
    navigator.serviceWorker.controller
      ? console.log(
          "[PWA Builder] active service worker found, no need to register"
        )
      : navigator.serviceWorker
          .register(config.pathRoot + "pwa.js", { scope: config.pathRoot })
          .then(function (e) {
            console.log(
              "Service worker has been registered for scope:" + e.scope
            );
          });
  }
});
